import { Link } from 'react-router-dom'
import { FadeInSection } from '../../../components/ui'
import { loadAuth } from '../../../lib/authStorage'

export default function FinalCTASection() {
  const isLoggedIn = Boolean(loadAuth()?.accessToken)

  return (
    <section
      className="relative overflow-hidden py-28 px-6"
      style={{
        backgroundColor: '#111',
        color: '#FBE6D4',
        borderBottom: '2px solid #111',
      }}
    >
      {/* Doodle accents */}
      <svg
        aria-hidden
        className="absolute top-12 left-12 hidden md:block"
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        style={{ opacity: 0.4 }}
      >
        <path
          d="M10 30 Q 30 5, 50 30 Q 30 55, 10 30"
          stroke="var(--accent)"
          strokeWidth="2.5"
          fill="none"
        />
      </svg>
      <svg
        aria-hidden
        className="absolute bottom-12 right-12 hidden md:block"
        width="80"
        height="40"
        viewBox="0 0 80 40"
        fill="none"
        style={{ opacity: 0.4 }}
      >
        <path
          d="M4 20 C 20 0, 40 40, 60 20 M 60 20 L 52 14 M 60 20 L 56 28"
          stroke="var(--accent)"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>

      <div className="relative max-w-3xl mx-auto text-center">
        <FadeInSection>
          <span
            className="inline-block text-xs font-bold uppercase font-dm-mono mb-6"
            style={{
              backgroundColor: 'var(--accent)',
              color: '#fff',
              padding: '5px 12px',
              borderRadius: 999,
              letterSpacing: '0.14em',
            }}
          >
            Ready when you are
          </span>

          <h2
            className="font-extrabold tracking-tight mb-6"
            style={{
              color: '#FBE6D4',
              fontSize: 'clamp(2.5rem, 6vw, 4.5rem)',
              lineHeight: 0.98,
              letterSpacing: '-0.035em',
            }}
          >
            Stop losing customers
            <br />
            you already earned.
          </h2>
          <p
            className="text-lg md:text-xl mb-10 max-w-xl mx-auto"
            style={{ color: 'rgba(251,230,212,0.75)', lineHeight: 1.55 }}
          >
            Set up Nudge in ten minutes. The next time a regular goes quiet,
            we'll bring them back for you.
          </p>

          {!isLoggedIn ? (
            <Link
              to="/signup"
              className="final-cta inline-flex items-center gap-2 transition-transform duration-150"
              style={{
                backgroundColor: 'var(--accent)',
                color: '#fff',
                padding: '18px 36px',
                borderRadius: 999,
                fontSize: '1rem',
                fontWeight: 700,
                textDecoration: 'none',
                border: '2px solid #FBE6D4',
                boxShadow: '5px 5px 0 #FBE6D4',
              }}
            >
              Get started free
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
                <path
                  d="M13 7l5 5-5 5M6 12h12"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          ) : (
            <Link
              to="/dashboard"
              className="final-cta inline-flex items-center gap-2 transition-transform duration-150"
              style={{
                backgroundColor: 'var(--accent)',
                color: '#fff',
                padding: '18px 36px',
                borderRadius: 999,
                fontSize: '1rem',
                fontWeight: 700,
                textDecoration: 'none',
                border: '2px solid #FBE6D4',
                boxShadow: '5px 5px 0 #FBE6D4',
              }}
            >
              Open dashboard
            </Link>
          )}

          <p
            className="text-sm mt-7 font-medium"
            style={{ color: 'rgba(251,230,212,0.55)' }}
          >
            Free plan · No credit card · Cancel any time
          </p>
        </FadeInSection>
      </div>

      <style>{`
        .final-cta:hover {
          transform: translate(-2px, -2px);
          box-shadow: 7px 7px 0 #FBE6D4 !important;
        }
        .final-cta:active {
          transform: translate(2px, 2px);
          box-shadow: 0 0 0 #FBE6D4 !important;
        }
      `}</style>
    </section>
  )
}
